module.exports = __webpack_public_path__ + "static/media/img-default.9eb97fdb.png";